import { createActions, createReducer } from 'reduxsauce';

/* ------------- Types and Action Creators ------------- */

export const { Types, Creators } = createActions({
  fetchPromptsRequest: [],
  fetchPromptsSuccess: ['prompts'],
  fetchPromptsFailure: ['error'],
  addPrompt: ['prompt'],
  updatePrompt: ['prompt'],
  deletePrompt: ['id'],
});

/* ------------- Initial State ------------- */

const INITIAL_STATE = {
  list: [],
  loading: false,
  error: null,
};

/* ------------- Reducers ------------- */

const fetchPromptsRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
  error: null,
});

const fetchPromptsSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  loading: false,
  list: action.prompts,
});

const fetchPromptsFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  loading: false,
  error: action.error,
});

const addPrompt = (state = INITIAL_STATE, action) => ({
  ...state,
  list: [action.prompt, ...state.list],
});

const updatePrompt = (state = INITIAL_STATE, action) => ({
  ...state,
  list: state.list.map((p) => (p.id === action.prompt.id ? action.prompt : p)),
});

const deletePrompt = (state = INITIAL_STATE, action) => ({
  ...state,
  list: state.list.filter((p) => p.id !== action.id),
});

/* ------------- Hook up Reducers to Types ------------- */

export default createReducer(INITIAL_STATE, {
  [Types.FETCH_PROMPTS_REQUEST]: fetchPromptsRequest,
  [Types.FETCH_PROMPTS_SUCCESS]: fetchPromptsSuccess,
  [Types.FETCH_PROMPTS_FAILURE]: fetchPromptsFailure,
  [Types.ADD_PROMPT]: addPrompt,
  [Types.UPDATE_PROMPT]: updatePrompt,
  [Types.DELETE_PROMPT]: deletePrompt,
});
